<template>
  <base-section
    id="venue"
  ><!---    style="padding-top: 0px !important"
--->
    <base-section-heading
      title="Congress Center"
    >
      ETS23 will be hosted in the <strong>San Servolo Congress Center</strong>.
    </base-section-heading>
    <v-container>
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
          md="4"
          class="d-flex child-flex"
        >
          <v-img
            :src="require('@/images/venue/view-from-air.jpg')"
            aspect-ratio="1"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="8"
          class="d-flex child-flex"
          align-self="center"
        >
          <base-section-heading
            divider="null"
            style="margin-bottom: 0px !important"
            :bodymarg="'margin-bottom: 0px !important'"
          >
            The Island of San Servolo, composed of a large architectural complex and a lovely park, was a monastic seat for a thousand years, then it housed psychiatric patients until the hospital’s closing following the psychiatric reform of 1978. Its first settlement dates back to the 7th century, when a group of Benedictine monks took refuge on the narrow and marshy island. In 1647, the complex was given to a group of Benedictine, Dominican and Franciscan nuns from the island of Candia. Next, the Senate of the Venetian Republic decided to use the Island of San Servolo to house the many injured who fled the clashes with the Turks. Medical services were provided by the Padri Ospedalieri di San Giovanni di Dio, now known as Fatebenefratelli. From that time on, the island’s history became closely linked with the authorities’ attitude toward disabling illnesses in general, and mental illness in particular. The Province of Venezia, now known as the Metropolitan City of Venice, retained ownership of the island. In the 1990s, it began an architectural recovery programme to protect and promote it through its in-house company, San Servolo – Servizi Metropolitani di Venezia.  A fascinating and original environment, the island is the perfect place to organise exclusive events in Venice. Just a few minutes by water bus from Piazza San Marco, the congress centre has numerous rooms for meetings and corporate and private events, exhibition areas and multipurpose spaces for cultural events. In the heart of one of Venice city centre’s largest parks, the residential centre can accommodate more than 300 guests in an international atmosphere.
          </base-section-heading>
        </v-col>
      </v-row>
      <br>
      <br>
      <v-carousel
        cycle
        height="400"
        hide-delimiter-background
        show-arrows-on-hover
      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
          :src="slide.src"
        >
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          />
        </v-carousel-item>
      </v-carousel>
      <br>
      <br>
        <v-footer
          id="regional-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in venuefooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < venuefooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    data () {
      return {
        isMobile: false,
        venuefooter: [
          {
            name: 'City of Venice',
            url: 'venice',
          },
          {
            name: 'Congress Center',
            url: 'congress-center',
          },
          {
            name: 'Hotel Rooms',
            url: 'hotel-rooms',
          },
          {
            name: 'Visa',
            url: 'visa',
          },
        ],
        slides: [
          {
            src: require('@/images/venue/esterno.jpg'),
          },
          {
            src: require('@/images/venue/auditorium-007.jpg'),
          },
          {
            src: require('@/images/venue/terrazza-011.jpg'),
          },
          {
            src: require('@/images/venue/terrazza-013.jpg'),
          },
          {
            src: require('@/images/venue/vedute-015.jpg'),
          },
          {
            src: require('@/images/venue/vedute-023.jpg'),
          },
          {
            src: require('@/images/venue/scirocco-177-001.jpg'),
          },
        ],
      }
    },
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
